module.exports = __webpack_public_path__ + "img/16.d8b821b4.gif";